<script setup lang="ts">
import { Button } from '~ds/components/ui/button';
import { Heading } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

import type { FeedbackSurveyQuestionYesNo } from './types';

import { feedbackQuestionLabel } from './types';

const props = defineProps<{
  question: FeedbackSurveyQuestionYesNo;
}>();

const model = defineModel<boolean | undefined>();
const { t } = useI18n();

const label = computed(() => feedbackQuestionLabel(props.question, t));
</script>

<template>
  <div class="flex flex-col items-center gap-6">
    <Heading
      size="md"
      as="h3"
      class="text-center max-w-sm"
    >
      {{ label }}
    </Heading>
    <div
      class="flex gap-4"
      role="radiogroup"
      :aria-label="label"
    >
      <Button
        type="button"
        role="radio"
        size="lg"
        :variant="model === true ? 'default' : 'outline'"
        :aria-checked="model === true"
        class="min-w-28 font-semibold"
        :class="{ 'scale-105': model === true }"
        @click="model = true"
      >
        {{ t('unified.common.yes') }}
      </Button>
      <Button
        type="button"
        role="radio"
        size="lg"
        :variant="model === false ? 'default' : 'outline'"
        :aria-checked="model === false"
        class="min-w-28 font-semibold"
        :class="{ 'scale-105': model === false }"
        @click="model = false"
      >
        {{ t('unified.common.no') }}
      </Button>
    </div>
  </div>
</template>
